module.exports = require("live/services/widgets");